<template>
	<div class="base_scroll_page" v-loading="loading">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">用户账号：</span>
					<el-input v-model="search_code" class="b_inp" placeholder="用户账号"></el-input>
				</div>
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startDate"
						:editable="false"
						placeholder="开始时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchStartDateChange"
					>
					</el-date-picker>
				</div>
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endDate"
						:editable="false"
						placeholder="结束时间"
						type="date"
						value-format="yyyy-MM-dd"
						@change="handleSearchEndDateChange"
					>
					</el-date-picker>
				</div>
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- action -->
			<div style="margin-top: 20px;font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">添加</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="userName"
						label="用户名称"
					>
					</el-table-column>
					<el-table-column
						prop="userCode"
						label="用户账号"
					>
					</el-table-column>
					<el-table-column
						prop="business"
						label="业务类型"
					>
					</el-table-column>
					<el-table-column
						prop="integral"
						label="积分值"
					>
					</el-table-column>
					<el-table-column
						prop="redeemLabel"
						label="兑换产品"
					>
					</el-table-column>
					<el-table-column
						prop="isReceiveLabel"
						label="是否领取"
					>
					</el-table-column>
					<el-table-column
						prop="receiveDate"
						label="领取日期"
					>
					</el-table-column>
					<el-table-column
						prop="operater"
						label="操作人"
					>
					</el-table-column>
					<el-table-column
						prop="operateTime"
						label="操作时间"
					>
					</el-table-column>
					<el-table-column
						prop="remark"
						label="备注"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增 -->
		<add
			v-model="add_display"
			@onSuccess="addSuccess"
		></add>
		<!-- 新增 end -->
	</div>
</template>

<script>
	import Add from './components/add.vue';
	import Api from '../../../../../../api/index.js';
	import { mapState } from 'vuex';
	
	export default{
		mounted() {
			this.findRecords();
		},
		data() {
			return{
				loading: false,
				
				search_code: '',
				search_startDate: '',
				search_endDate: '',
				
				total: 0,
				currentPage: 1,
				tableData: [],
				
				add_display: false
			}
		},
		computed: {
			...mapState([
				'iAssistantIntegralProduct'
			])
		},
		methods: {
			/******************** @Events *************************/
			// 开始时间
			handleSearchStartDateChange() {
				this.compareSearchDate();
			},
			// 结束时间
			handleSearchEndDateChange() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.findRecords();
			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.findRecords();
				}
			},
			// 点击添加
			handleAddClick() {
				this.add_display = true;
			},
			
			/******************** @Function *************************/
			// 获取所有记录列表
			findRecords() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					yiCode: that.search_code,
					start: that.search_startDate,
					end: that.search_endDate
				};
				Api.findIAssistantIntegralRecords(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								userName: v.wuserName || '',
								userCode: v.ucode || '',
								business: that.getBusinessLabelById(v.pointsFrom),
								integral: v.pointsValue || '',
								redeemId: v.productId || '',
								redeemLabel: that.getRedeemLabelById(v.productId),
								isReceiveLabel: v.pointsGainFlag == 1 ? '已领取' : (v.pointsGainFlag == 2 ? '未领取' : ''),
								receiveDate: v.timeGain || '',
								operater: v.optUserName || '',
								operateTime: v.createTs || '',
								remark: ''
							});
						});
						that.tableData = list;
						that.total = res.data.data.total;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 根据业务id获取业务名
			getBusinessLabelById(id) {
				// 1-训练 2-分享 3-邀请 4-后台赠送 100-兑换
				let label = '';
				switch(id) {
					case 1:
						label = '训练';
						break;
					case 2:
						label = '分享';
						break;
					case 3:
						label = '邀请';
						break;
					case 4:
						label = '后台赠送';
						break;
					case 5:
						label = '等级奖励';
						break;
					case 6:
						label = '消费抵扣';
						break;
					case 100:
						label = '兑换';
						break;
				}
				return label;
			},
			// 根据产品id获取产品名称
			getRedeemLabelById(id) {
				let label = '';
				this.iAssistantIntegralProduct.forEach(v => {
					if (id == v.id) {
						label = v.label;
					}
				});
				return label;
			},
			// 新增成功
			addSuccess() {
				this.findRecords();
			},
			// 修改成功
			updateSuccess() {
				this.findRecords();
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startTime = new Date(this.search_startDate).getTime(),
						endTime = new Date(this.search_endDate).getTime();
					if (endTime < startTime) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间！');
					}
				}
			}
		},
		components: {
			Add
		}
	}
</script>

<style>
</style>
